import { axios } from '~/clients';
import { GET_DELIVERY_PICKUP } from '~/constants/endpoints';
import { InventoryTypeKey } from '~/constants/inventoryType';
import { DeliveryPickupResponse } from '~/services/common/contracts';
import { BrowserCookies } from '~/utilities';

export const fetchDeliveryPickupData = (
  {
    correlationId,
    inventoryType,
    locationId,
    saleStatus,
    userId,
    vehicleId,
    zip
  }: {
    correlationId: string;
    inventoryType: InventoryTypeKey;
    locationId: number;
    saleStatus: string;
    userId: string;
    vehicleId: number;
    zip: string;
  },
  controller: AbortController
) =>
  axios.post<DeliveryPickupResponse>(
    GET_DELIVERY_PICKUP,
    {
      userId,
      vehicles: [
        {
          vehicleId,
          vehicleLocationId: locationId,
          vehicleSaleStatus: saleStatus,
          vehicleInventoryType: inventoryType
        }
      ],
      zipCode: zip
    },
    {
      headers: {
        browsercookieid: BrowserCookies.get('BrowserCookieId') ?? '',
        clientid: 'vdp_ui',
        correlationId
      },
      signal: controller.signal
    }
  );

export default fetchDeliveryPickupData;
